import { ActionDelegate } from 'containers/Base/ActionDelegate';
import { UndefinedAble } from 'data/base';
import { Module } from 'data/terra/Module';
import { ModuleSelectorAction } from './actionTypes';
import { fetchModulesDelegate } from './actions/FetchModules';
import { addModuleDelegate } from './actions/AddModule';
import { selectModuleDelegate } from './actions/SelectModule';

export interface ModuleSelectorState {
  modules: Module[];
  selectedModule: UndefinedAble<Module>;
}

const initialState: ModuleSelectorState = {
  modules: [],
  selectedModule: undefined,
};

const delegates: {
  [key: string]: ActionDelegate<any, ModuleSelectorState>;
} = {
  ...addModuleDelegate,
  ...fetchModulesDelegate,
  ...selectModuleDelegate,
};

export default function reduce(
  state: ModuleSelectorState = initialState,
  action: ModuleSelectorAction
): ModuleSelectorState {
  const delegate = delegates[action.type];
  if (delegate) {
    return delegate(state, action);
  } else {
    return state;
  }
}
